export default __webpack_public_path__ + "static/media/coindemo1.c37e7908.svg";